module.exports = __webpack_public_path__ + "static/media/icon_shobadc92155918d94fb69d582ea9ba07a0.webp";